var _excluded = ["event", "date", "theme"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled, { withTheme, css } from 'styled-components';
import { shape, string } from 'prop-types';
import { Time } from '@gympass/yoga-icons';
import Card from '../Card';
import { TextRenderer, Text } from '../../../Text/web/Text';
var Event = styled(Card)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n"])));
var EventInfo = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var event = _ref.theme.yoga.components.card.event;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    padding: ", "px ", "px\n      ", "px ", "px;\n\n    ", ", ", " {\n      display: -webkit-inline-box;\n      overflow: hidden;\n\n      -webkit-line-clamp: 1;\n      -webkit-box-orient: vertical;\n      text-overflow: ellipsis;\n      text-overflow: -o-ellipsis-lastline;\n    }\n\n    ", " {\n      height: ", "px;\n      margin-bottom: ", "px;\n\n      font-weight: ", ";\n      font-size: ", "px;\n    }\n\n    ", " {\n      height: ", "px;\n      margin-bottom: ", "px;\n\n      color: ", ";\n      font-weight: ", ";\n    }\n  "])), event.info.padding.top, event.info.padding.right, event.info.padding.bottom, event.info.padding.left, TextRenderer, Text.Small, TextRenderer, event.info.name.height, event.info.name.marginBottom, event.info.name.fontWeight, event.info.name.fontSize, Text.Small, event.info.place.height, event.info.place.marginBottom, event.info.place.color, event.info.name.fontWeight);
});
var EventTime = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n"])));
var DateInfo = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var event = _ref2.theme.yoga.components.card.event;
  return "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n\n    width: 56px;\n    background-color: " + event.date.backgroundColor + ";\n  ";
});
var DayOfWeek = styled(Text.Small)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref3) {
  var event = _ref3.theme.yoga.components.card.event;
  return "\n    margin-bottom: " + event.date.dayOfWeek.marginBottom + "px;\n\n    font-weight: " + event.date.dayOfWeek.fontWeight + ";\n  ";
});
var Month = styled(Text.Small)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref4) {
  var event = _ref4.theme.yoga.components.card.event;
  return "\n    font-weight: " + event.date.month.fontWeight + ";\n  ";
});

var EventCard = function EventCard(_ref5) {
  var event = _ref5.event,
      date = _ref5.date,
      icon = _ref5.theme.yoga.components.card.event.icon,
      rest = _objectWithoutPropertiesLoose(_ref5, _excluded);

  return /*#__PURE__*/React.createElement(Event, rest, /*#__PURE__*/React.createElement(DateInfo, null, /*#__PURE__*/React.createElement(DayOfWeek, {
    inverted: true
  }, date.dayOfWeek), /*#__PURE__*/React.createElement(Text.H5, {
    inverted: true
  }, date.day), /*#__PURE__*/React.createElement(Month, {
    inverted: true
  }, date.month)), /*#__PURE__*/React.createElement(EventInfo, null, /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    title: event.name
  }, event.name), /*#__PURE__*/React.createElement(Text.Small, {
    title: event.place
  }, event.place), /*#__PURE__*/React.createElement(EventTime, null, /*#__PURE__*/React.createElement(Time, {
    fill: icon.fill,
    style: {
      marginRight: 5
    }
  }), /*#__PURE__*/React.createElement(Text.Tiny, null, event.time))));
};

EventCard.propTypes = {
  /** event information: { name (string), place (string), time (string) } */
  event: shape({
    name: string,
    place: string,
    time: string
  }).isRequired,

  /** date information: { day (string), dayOfWeek (string), month (string) } */
  date: shape({
    day: string,
    dayOfWeek: string,
    month: string
  }).isRequired
};
EventCard.displayName = 'EventCard';
export default withTheme(EventCard);